<template>
  <div id="app">
    <b-container fluid>
      <b-row>
        <b-col>
          <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
        </b-col>
      </b-row>
      <b-card class="mainCardBG">
        <b-card-text>
          <b-row>
            <b-col md="7" class="my-1 d-flex align-items-center">
              <b-button @click="goBack" size="sm" variant="outline-secondary">
                <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon> Back
              </b-button>
              <h5 class="mt-1 ml-2">{{ $route.name }}</h5>
            </b-col>
            <b-col md="4">
              <b-button
                class="pull-right ml-1 mt-1"
                :variant="
                  Filter.PORFilter ||
                  Filter.PODFilter ||
                  Filter.branchFilter ||
                  Filter.containerTypeFilter ||
                  Filter.commonFilter ||
                  Filter.PrealertFilter ||
                  Filter.fclLclFilter ||
                  Filter.shippingLineFilter ||
                  Filter.containerNoFilter ||
                  Filter.BookingNoFilter ||
                  Filter.SOBFilter ||
                  Filter.SOBStatusFilter ||
                  Filter.JobNoFilter ||
                  Filter.billingFilter ||
                  Filter.finalBillingFilter ||
                  Filter.clientIDFilter ||
                  Filter.userFilter ||
                  Filter.statusFilter ||
                  Filter.dateRange.startDate ||
                  Filter.dateRange.endDate
                    ? 'outline-danger'
                    : 'outline-primary'
                "
                :class="' ml-4' + visible ? null : 'collapsed'"
                :aria-expanded="visible ? 'true' : 'false'"
                aria-controls="collapse-4"
                @click="visible = !visible"
                style="font-size: 0.675rem"
                >{{
                  Filter.PORFilter ||
                  Filter.PODFilter ||
                  Filter.branchFilter ||
                  Filter.containerTypeFilter ||
                  Filter.commonFilter ||
                  Filter.PrealertFilter ||
                  Filter.SOBFilter ||
                  Filter.shippingLineFilter ||
                  Filter.SOBStatusFilter ||
                  Filter.BookingNoFilter ||
                  Filter.fclLclFilter ||
                  Filter.containerNoFilter ||
                  Filter.JobNoFilter ||
                  Filter.billingFilter ||
                  Filter.finalBillingFilter ||
                  Filter.clientIDFilter ||
                  Filter.userFilter ||
                  Filter.statusFilter ||
                  Filter.dateRange.startDate ||
                  Filter.dateRange.endDate
                    ? "Filter ON"
                    : "Filter OFF"
                }}</b-button
              >

              <b-button
                class="pull-right ml-1 mt-1"
                v-if="data.length > 0"
                :disabled="ExcelBtnName != 'Export As Excel' ? true : false"
                @click="getReports('getBLPendencyList', 'Export As Excel')"
                size="sm"
                variant="warning"
                style="font-size: 0.675rem"
              >
                {{ ExcelBtnName }}
                <b-spinner
                  v-if="ExcelBtnName != 'Export As Excel'"
                  small
                  label="Small Spinner"
                ></b-spinner
              ></b-button>
            </b-col>
            <b-col md="1" class="d-flex align-items-center">
              <h5>
                <small v-if="!isLoading">{{ total }} Entries</small>
              </h5>
            </b-col>
          </b-row>
          <div v-if="visible">
            <b-card>
              <b-collapse v-model="visible" id="collapse-2">
                <b-row>
                  <b-col md="3">
                    <label>Status</label>

                    <model-list-select
                      :list="SOBStatusList"
                      v-model="Filter.SOBFilter"
                      option-value="inv"
                      option-text="int"
                      placeholder="Select"
                      @input="getBLPendencyList('Normal', '0', '0', '1', '1')"
                    ></model-list-select>
                  </b-col>
                  <b-col md="3">
                    <label>FCL/LCL</label>
                    <model-list-select
                      :list="flTypeList"
                      v-model="Filter.fclLclFilter"
                      option-value="flVal"
                      option-text="flText"
                      placeholder="Select FCL / LCL"
                      @input="getBLPendencyList('Normal', '0', '0', '1', '1')"
                    ></model-list-select>
                  </b-col>
                  <b-col md="3">
                    <label>Months/Year</label>
                    <model-list-select
                      @input="getBLPendencyList('Normal', '0', '0', '1', '1')"
                      :list="dateStatusList"
                      v-model="Filter.dateStatusFilter"
                      option-value="inv"
                      option-text="int"
                      placeholder="Select Date Filter"
                    ></model-list-select>
                  </b-col>
                  <b-col md="3">
                    <label>Invoice Status</label>
                    <model-list-select
                      @input="getBLPendencyList('Normal', '0', '0', '1', '1')"
                      :list="invoiceStatusList"
                      v-model="Filter.billingFilter"
                      option-value="inv"
                      option-text="int"
                      placeholder="Select Status"
                    ></model-list-select>
                  </b-col>
                  <b-col md="3">
                    <label>Billing Status</label>
                    <model-list-select
                      @input="getBLPendencyList('Normal', '0', '0', '1', '1')"
                      :list="billingStatusList"
                      v-model="Filter.finalBillingFilter"
                      option-value="inv"
                      option-text="int"
                      placeholder="Select Billing Status"
                    ></model-list-select>
                  </b-col>
                  <b-col md="3">
                    <label>Prealert Status</label>
                    <model-list-select
                      @input="getBLPendencyList('Normal', '0', '0', '1', '1')"
                      :list="PrealertStatusList"
                      v-model="Filter.PrealertFilter"
                      option-value="inv"
                      option-text="int"
                      placeholder="Select Prealert Status"
                    ></model-list-select>
                  </b-col>
                  <b-col md="3">
                    <label>Date</label>
                    <date-range-picker
                      :always-show-calendars="showCal"
                      v-model="Filter.dateRange"
                      :startDate="startDate"
                      :endDate="endDate"
                      :locale-data="locale"
                      :disabled="Filter.DFlag ? true : false"
                      @update="getBLPendencyList('Normal', '0', '0', '1', '1')"
                    ></date-range-picker>
                  </b-col>
                  <b-col md="3">
                    <label>Shipping Line</label>
                    <model-list-select
                      :list="$store.getters['common/getAllShippingLineList']"
                      v-model="Filter.shippingLineFilter"
                      option-value="shippingId"
                      option-text="shippingLine"
                      placeholder="Select Shipping Line"
                      @input="getBLPendencyList('Normal', '0', '0', '1', '1')"
                    ></model-list-select>
                  </b-col>
                  <b-col md="3">
                    <label>SHIPPER<span class="error">*</span></label>
                    <model-list-select
                      :list="$store.getters['common/getAllClientList']"
                      id="clientfilter"
                      v-model="Filter.clientIDFilter"
                      option-value="clientId"
                      option-text="clientName"
                      placeholder="Select SHIPPER"
                      @input="getBLPendencyList('Normal', '0', '0', '1', '1')"
                    ></model-list-select>
                  </b-col>
                  <b-col md="3">
                    <label>SOB Today</label>

                    <model-list-select
                      :list="SOBTYTStatusList"
                      v-model="Filter.SOBStatusFilter"
                      option-value="inv"
                      option-text="int"
                      placeholder="Select"
                      @input="getBLPendencyList('Normal', '0', '0', '1', '1')"
                    ></model-list-select>
                  </b-col>
                  <b-col md="3">
                    <label>Common Filter</label>
                    <b-form-input
                      type="text"
                      :formatter="capitalizeAll"
                      placeholder="Search Common Filter"
                      id="commonFilter"
                      name="commonFilter"
                      autocomplete="off"
                      v-model="Filter.commonFilter"
                      @input="getBLPendencyList('Normal', '0', '0', '1', '1')"
                    ></b-form-input>
                  </b-col>
                  <b-col md="3">
                    <label>Job No Filter</label>
                    <b-form-input
                      type="text"
                      :formatter="capitalizeAll"
                      placeholder="Search JobNo Filter"
                      id="JobNoFilter"
                      name="JobNoFilter"
                      autocomplete="off"
                      v-model="Filter.JobNoFilter"
                      @input="getBLPendencyList('Normal', '0', '0', '1', '1')"
                    ></b-form-input>
                  </b-col>
                  <b-col md="3">
                    <label>Container No Filter</label>
                    <b-form-input
                      type="text"
                      :formatter="capitalizeAll"
                      placeholder="Search Container No Filter"
                      id="containerNoFilter"
                      name="containerNoFilter"
                      autocomplete="off"
                      v-model="Filter.containerNoFilter"
                      @input="getBLPendencyList('Normal', '0', '0', '1', '1')"
                    ></b-form-input>
                  </b-col>
                  <b-col md="3">
                    <label>
                      <b> Booking No. </b>
                    </label>
                    <b-form-input
                      :formatter="capitalizeAll"
                      placeholder="Booking No."
                      id="validBookingNo"
                      name="validBookingNo"
                      v-model="Filter.BookingNoFilter"
                      @input="getBLPendencyList('Normal', '0', '0', '1', '1')"
                    ></b-form-input>
                  </b-col>
                  <b-col md="3">
                    <label>
                      <b> Created User </b>
                    </label>
                    <model-list-select
                      :list="$store.getters['common/getAllUserList']"
                      id="userFilter"
                      @input="getBLPendencyList('Normal', '0', '0', '1', '1')"
                      v-model="Filter.userFilter"
                      option-value="userId"
                      option-text="employeeName"
                      placeholder="Select Created User"
                    ></model-list-select>
                  </b-col>
                  <b-col md="3">
                    <label>POR</label>
                    <model-list-select
                      @input="getLocationList($event, 'All', 'finalAllPlaceDataPOR')"
                      @searchchange="
                        getLocationList($event, 'All', 'finalAllPlaceDataPOR')
                      "
                      :list="$store.getters['common/getAllPORList']"
                      v-model="Filter.PORFilter"
                      option-value="pickupId"
                      option-text="pickupLocation"
                      placeholder="Select Place of Receipt"
                      @update="getBLPendencyList('Normal', '0', '0', '1', '1')"
                    ></model-list-select>
                  </b-col>
                  <b-col md="3">
                    <label>POD</label>
                    <model-list-select
                      @input="getLocationList($event, 'All', 'finalAllPlaceDataPOD')"
                      @searchchange="
                        getLocationList($event, 'All', 'finalAllPlaceDataPOD')
                      "
                      :list="$store.getters['common/getAllPODList']"
                      v-model="Filter.PODFilter"
                      option-value="pickupId"
                      option-text="pickupLocation"
                      placeholder="Select Port of Discharge"
                      @update="getBLPendencyList('Normal', '0', '0', '1', '1')"
                    ></model-list-select>
                  </b-col>
                  <b-col md="3">
                    <label>Branch</label>
                    <!-- :isDisabled="
                        $sessionsStorage.get('designation') != 'Admin' &&
                        $sessionsStorage.get('nameUser') != 'Bhavneesh'
                          ? true
                          : false
                      " -->
                    <model-list-select
                      class="ml-1"
                      :list="$store.getters['common/getAllBranchList']"
                      id="branchfilter"
                      v-model="Filter.branchFilter"
                      option-value="pickupId"
                      option-text="pickupLocation"
                      placeholder="All"
                      @input="getBLPendencyList('Normal', '0', '0', '1', '1')"
                     
                    ></model-list-select>
                  </b-col>
                  <b-col md="3">
                    <label>Container Type</label>
                    <model-list-select
                      :list="$store.getters['common/getAllContainerTypeList']"
                      v-model="Filter.containerTypeFilter"
                      option-value="containerTypeId"
                      option-text="containerType"
                      placeholder="Select Container Type"
                      @input="getBLPendencyList('Normal', '0', '0', '1', '1')"
                    ></model-list-select>
                  </b-col>
                  <b-col md="12" class="mt-2">
                    <b-button
                      size="sm"
                      style="margin-left: auto"
                      class="ml-1 pull-right"
                      @click="clearFilter"
                      variant="outline-danger"
                      >Reset</b-button
                    >
                  </b-col>
                </b-row>
              </b-collapse>
            </b-card>
          </div>
          <b-row>
            <b-col md="12">
              <div class="pagination">
                <b-button
                  size="sm"
                  @click="prevPage"
                  :disabled="pagination.currentPage === 1"
                  >Previous</b-button
                >
                <b-button
                  v-for="pageNumber in pageNumbers"
                  :key="pageNumber"
                  @click="setPage(pageNumber)"
                  :class="{ active: pageNumber === pagination.currentPage }"
                >
                  {{ pageNumber }}
                </b-button>
                <b-button
                  size="sm"
                  @click="nextPage"
                  :disabled="pagination.currentPage === totalPages"
                  >Next</b-button
                >
              </div>
              <div class="table-responsive mt-3">
                <table class="table table-bordered table-hover">
                  <thead>
                    <tr>
                      <th>SN.</th>
                      <th
                        v-for="field in fields"
                        :key="field.key"
                        @click="sortBy(field.key)"
                        class="table-header"
                      >
                        {{ field.label }}
                        <span
                          v-if="sortKey === field.key"
                          class="mdi"
                          :class="
                            sortOrders[field.key] > 0 ? 'mdi-arrow-up' : 'mdi-arrow-down'
                          "
                        ></span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in sortedData" :key="index">
                      <td>{{ index + 1 }}</td>
                      <td v-for="field in fields" :key="field.key" class="table-body">
                        <span v-if="field.key != 'actions'">{{ item[field.key] }}</span>
                        <span v-else>
                          <button class="btn btn-sm btn-primary" @click="editRow(item)">
                            Edit
                          </button>
                          <button class="btn btn-sm btn-danger" @click="deleteRow(item)">
                            Delete
                          </button></span
                        >
                      </td>
                    </tr>
                  </tbody>
                </table>

                <!-- <b-button @click="nextPage()" :disabled="currentPage >= pageCount" size="sm"
                >Next</b-button
              > -->
              </div>

              <div class="pagination">
                <b-button
                  size="sm"
                  @click="prevPage"
                  :disabled="pagination.currentPage === 1"
                  >Previous</b-button
                >
                <b-button
                  v-for="pageNumber in pageNumbers"
                  :key="pageNumber"
                  @click="setPage(pageNumber)"
                  :class="{ active: pageNumber === pagination.currentPage }"
                >
                  {{ pageNumber }}
                </b-button>
                <b-button
                  size="sm"
                  @click="nextPage"
                  :disabled="pagination.currentPage === totalPages"
                  >Next</b-button
                >
              </div>
            </b-col>
          </b-row>
        </b-card-text>
      </b-card>
    </b-container>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import CustomLoader from "../common/customLoader.vue";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { lastVisitPage, globalPermissionStatus } from "../../helper/collection";
import DateRangePicker from "vue2-daterange-picker";
import CommonService from "../../services/CommonService.js";
import { ModelListSelect, MultiSelect } from "vue-search-select";
import Multiselect from "vue-multiselect";
export default {
  beforeMount() {
    if (globalPermissionStatus("Sea Freight")) {
      lastVisitPage(this.$router.history.current.fullPath);
      this.$store.dispatch(
        "common/setAllUserList",
        JSON.stringify({
          itemCode: "GET_USERLIST_Data",
        })
      );
      this.$store.dispatch(
        "common/setAllClientList",
        JSON.stringify({
          itemCode: "ClientList",
        })
      );
      this.$store.dispatch(
        "common/setAllShippingLineList",
        JSON.stringify({
          itemCode: "ShippingLineList",
        })
      );
      this.$store.dispatch(
      "common/setAllBranchList",
      JSON.stringify({
        filter: "BranchList",
        active: "all",
      })
    );
      this.$store.dispatch(
        "common/setAllContainerTypeList",
        JSON.stringify({
          itemCode: "ContainerTypeList",
        })
      );
      this.$store.dispatch(
        "common/setAllLocationDetailsFinalList",
        JSON.stringify({
          itemCode: "LocationDetailsFinalList",
        })
      );
      this.$store.dispatch(
        "common/setAllPORList",
        JSON.stringify({
          itemCode: "PORList",
        })
      );
      this.$store.dispatch(
        "common/setAllPODList",
        JSON.stringify({
          itemCode: "PODList",
          type: "Normal",
          Territory: "",
        })
      );
      this.$store.dispatch(
        "common/setAllPOLList",
        JSON.stringify({
          itemCode: "POLList",
        })
      );
      this.$store.dispatch("setCurrentRoute", "/bl-pendency");
      if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
        this.fetchLastPage(this.lastVisitPage);
      } else {
        this.getBLPendencyList("Normal", "0", "0", "1", "1");
      }
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },
  data() {
    return {
      nextPageNo: 1,
      selectDateFormat,
      total: 0,
      data: [],
      ExcelBtnName: "Export As Excel",
      fields: [
        
      { key: "JOBNO", label: "JOB NO" },
        { key: "JOBDate", label: "JOB Date" },
        { key: "shippingLine", label: "Shipping Line" },
        { key: "validBookingNo", label: "Booking No" },
        { key: "FCL_LCL", label: "FCL/LCL" },
        { key: "POR", label: "POR" },
        { key: "POL", label: "POL" },
        { key: "POD", label: "POD" },
        { key: "FPOD", label: "FPOD" },
        { key: "clientName", label: "SHIPPER" },
        { key: "freightContainers", label: "Containers" },
        { key: "multipleContainerType", label: "Containers Type" },
        { key: "si_cutoff_est", label: "SI CUTOF" },
        { key: "SI_Submissiondate_actual", label: "SI Submissiondate" },
        { key: "SINVNO", label: "Shipper INV NO" },
        { key: "SBILLNO", label: "Shipping Bill NO." },
        { key: "CUST_SEAL_NO", label: "Custom Seal NO" },
        { key: "LINE_SEAL_NO", label: "Line Seal NO" },

        { key: "SOB_est", label: "SOB Estimated" },
        { key: "SysSOB", label: "Sys SOB" },
        { key: "SOB", label: "SOB" },
        { key: "MBLNO", label: "MBL NO" },
        { key: "mbl_date", label: "MBL Date" },
        { key: "mbl_release_date", label: "MBL Release Date" },
        { key: "HBLNO", label: "HBL NO" },
        { key: "vessel_voyage", label: "Vessel/Voyage" },
        { key: "ETA_estimated", label: "ETA Estimated" },
        { key: "SysETA_estimated", label: "Sys ETA Estimated" },
        { key: "ETA_actual", label: "ETA Actual" },
        { key: "SysETA_actual", label: "Sys ETA Actual" },
        { key: "ETA_destination_estimated", label: "ETA Destination Estimated" },
        { key: "ETA_destination_actual", label: "ETA Destination Actual" },
        { key: "oe_payment_date_first", label: "OF Sline First Date" },
        { key: "is_prealertSend", label: "Prealert Send Status" },
        { key: "is_manifestation_status", label: "Manifestation STATUS" },
        { key: "TallyBillingSeries", label: "Tally Bill No" },
        { key: "finalBillingCompletedStatus", label: "Final Billing Status" },
        { key: "is_billingType_status", label: "Billing Type" },
        { key: "invExpense", label: "Exp INV No" },
        { key: "invReverse", label: "Reverse INV No" },

        { key: "cb_booking_date_est", label: "Booking Estimated" },
        { key: "cb_validity_booking_date_est", label: "Booking validity Estimated" },
        { key: "vgmcut_off_date_est", label: "VGM Cut Off EST" },
        { key: "VGM_submissionDate_actual", label: "VGM Submission" },
        { key: "tr_cutoff_date_est", label: "TR Cut Off EST" },
        { key: "tr_Submissiondate_actual", label: "TR Submission" },
        { key: "handover_cutoff_date_est", label: "Handover Cut Off" },
        { key: "handoverDate_actual", label: "Handover Actual" },

        { key: "sub_noti_risk_verbose", label: "Risk Status" },
        { key: "sub_noti_risk_description", label: "Risk Description" },
        { key: "sub_noti_conclusion", label: "Risk Conclusion" },
        { key: "sub_noti_event_message", label: "Event Message" },
        { key: "status_verbose", label: "Status Verbose" },
        { key: "ETA_loadport_initial", label: "ETA Loadport Initial" },
        { key: "Eta_loadport_actual", label: "ETA Loadport Actual" },
      ],
      flTypeList: [
        {
          flVal: "fcl",
          flText: "FCL",
        },
        {
          flVal: "lcl",
          flText: "LCL",
        },
      ],
      dateStatusList: [
        {
          inv: "125",
          int: "4 Month",
        },
        {
          inv: "186",
          int: "6 Month",
        },
        {
          inv: "248",
          int: "8 Month",
        },
        {
          inv: "300",
          int: "10 Month",
        },
        {
          inv: "367",
          int: "1 Year",
        },
        {
          inv: "734",
          int: "2 Year",
        },

        {
          inv: "0",
          int: "Global ALL",
        },
      ],
      invoiceStatusList: [
        {
          inv: "1",
          int: "In-Progress",
        },
        {
          inv: "2",
          int: "Sent to Accounts",
        },
        {
          inv: "3",
          int: "Billing Not Started",
        },
        {
          inv: "4",
          int: "Not To Be Billed",
        },
        {
          inv: "",
          int: "All",
        },
      ],
      billingStatusList: [
        {
          inv: "1",
          int: "Completed",
        },
        {
          inv: "0",
          int: "Pending",
        },
        {
          inv: "",
          int: "All",
        },
      ],
      PrealertStatusList: [
        {
          inv: "1",
          int: "Yes",
        },
        {
          inv: "2",
          int: "No",
        },
        {
          inv: "3",
          int: "All",
        },
      ],
      SOBStatusList: [
        {
          inv: "1",
          int: "Sailed",
        },
        {
          inv: "2",
          int: "Not Sailed",
        },
        {
          inv: "3",
          int: "All",
        },
      ],
      SOBTYTStatusList: [
        {
          inv: "0",
          int: "Today",
        },
        {
          inv: "1",
          int: "Tommorow",
        },
        {
          inv: "2",
          int: "Yesterday",
        },
        {
          inv: "3",
          int: "Next 7 Days",
        },
        {
          inv: "4",
          int: "Previous 7 Days",
        },
        {
          inv: "5",
          int: "All",
        },
      ],

      Filtervisible: false,
      visible: false,
      activeButtonBranch: false,
      activeButtonClient: false,

      sortKey: "",
      sortOrders: {},
      Filter: {
        PORFilter: "",
        PODFilter: "",
        branchFilter: "",
        containerTypeFilter: "",
        BookingNoFilter: "",
        JobNoFilter: "",
        userFilter: this.$sessionsStorage.get("userId"),
        activeButtonFilter: "",
        activeTallyBLFilter: "PendingInvoice",
        billingFilter: "",
        finalBillingFilter: "0",
        dateStatusFilter: "125",
        SOBFilter: "3",
        SOBStatusFilter: "0",
        shippingLineFilter: "",
        PrealertFilter: "3",
        fclLclFilter: "",
        containerNoFilter: "",
        commonFilter: "",
        clientIDFilter: "",
        createdByFilter: "",
        statusFilter: "2",
        dateRange: {
          startDate: "",
          endDate: "",
        },
        startDate: "",
        endDate: "",
      },
      openLeft: "left",
      showCal: false,
      startDate: "2017-09-05",
      endDate: "2017-09-15",
      dateRange: {
        startDate: "",
        endDate: "",
      },
      locale: {
        direction: "ltr",
        format: "mm/dd/yyyy",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        monthNames: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        firstDay: 0,
      },
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      value1: [new Date(2019, 9, 8), new Date(2019, 9, 19)],
      value2: [],
      langType: {
        pickers: ["Today", "Yesterday", "This Month", "This Year"],
      },
      time: "",
      date: "",
      week: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],

      langEnq: {
        pickers: ["", "", "previous 7 days", "previous 30 days"],
      },
      isLoading: false,

      pagination: {
        currentPage: 1,
        perPage: 25,
        pageOptions: [5, 10, 15],
      },
      // sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
    };
  },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },
  beforeDestroy() {},
  components: {
    CustomLoader,
    DatePicker,
    ModelListSelect,
    DateRangePicker,

    MultiSelect,
    Multiselect,
  },
  computed: {
    pageNumbers() {
      return Array.from({ length: this.totalPages }, (_, i) => i + 1);
    },
    totalPages() {
      return Math.ceil(this.total / this.pagination.perPage);
    },
    paginatedItems() {
      const start = (this.pagination.currentPage - 1) * this.pagination.perPage;
      const end = start + this.pagination.perPage;
      return this.items.slice(start, end);
    },
    sortedData() {
      const sortKey = this.sortKey;
      const order = this.sortOrders[sortKey] || 1;
      if (!sortKey) {
        return this.data;
      }
      return this.data.slice().sort((a, b) => {
        if (a[sortKey] > b[sortKey]) {
          return order;
        } else if (a[sortKey] < b[sortKey]) {
          return -order;
        }
        return 0;
      });
    },
  },
  created() {
    this.fields.forEach((field) => {
      this.sortOrders[field.key] = 1;
    });
  },
  methods: {
    setPage(pageNumber) {
      this.pagination.currentPage = pageNumber;
      this.getBLPendencyList("Normal", "0", "0", "1", "1");
    },
    nextPage() {
      if (this.pagination.currentPage < this.totalPages) {
        this.pagination.currentPage++;
      }
      this.getBLPendencyList("Normal", "0", "0", "1", "1");
    },
    prevPage() {
      if (this.pagination.currentPage > 1) {
        this.pagination.currentPage--;
      }
      this.getBLPendencyList("Normal", "0", "0", "1", "1");
    },
    // nextPage(){
    //   this.nextPageNo+=1;
    //   this.getBLPendencyList('Normal', '0', '0', '1', '1')
    // },
    clearFilter() {
      this.Filter = {
        PORFilter: "",
        PODFilter: "",
        branchFilter: "",
        containerTypeFilter: "",
        BookingNoFilter: "",
        JobNoFilter: "",
        userFilter: this.$sessionsStorage.get("userId"),
        activeButtonFilter: "",
        activeTallyBLFilter: "PendingInvoice",
        billingFilter: "",
        finalBillingFilter: "0",
        dateStatusFilter: "125",
        SOBFilter: "3",
        SOBStatusFilter: "0",
        shippingLineFilter: "",
        PrealertFilter: "3",
        fclLclFilter: "",
        containerNoFilter: "",
        commonFilter: "",
        clientIDFilter: "",
        createdByFilter: "",
        statusFilter: "2",
        dateRange: {
          startDate: "",
          endDate: "",
        },
        startDate: "",
        endDate: "",
      };
    },
    getCurrentLastDate() {
      var today = new Date();
      var firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
      var lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);

      var firstDay_dd = String(firstDay.getDate()).padStart(2, "0");
      var firstDay_mm = String(firstDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var firstDay_yyyy = firstDay.getFullYear();

      var lastDay_dd = String(lastDay.getDate()).padStart(2, "0");
      var lastDay_mm = String(lastDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var lastDay_yyyy = lastDay.getFullYear();

      firstDay = firstDay_yyyy + "/" + firstDay_mm + "/" + firstDay_dd; //2018-06-01
      lastDay = lastDay_yyyy + "/" + lastDay_mm + "/" + lastDay_dd; //2018-06-01

      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();
      today = yyyy + "/" + mm + "/" + dd; //2018-06-01
      this.startDate = today;
      this.Filter.dateRange = {
        startDate: firstDay,
        endDate: lastDay,
      };
    },
    sortBy(key) {
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
    },
    goBack() {
      window.history.go(-1);
    },
    editRow(item) {
      // Implement your editRow functionality here
    },
    deleteRow(item) {
      // Implement your deleteRow functionality here
    },
    onFiltered(filtered) {
      this.totalRows = filtered.length;
      this.pagination.currentPage = 1;
    },
    debounceSearch(event) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.getBLPendencyList("Normal", "0", "0", "1", "1");
      }, 1000);
    },
    getReports(id, btnName) {
      this.isLoading = true;
      this.ExcelBtnName = "Downloading Please Wait .....";
      this.getBLPendencyList("Excell", "0", "0", "1", "1");
    },
    fetchLastPage(event) {
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = parseInt(event) * this.pagination.perPage - this.pagination.perPage;
      }
      this.getBLPendencyList("Normal", "0", CURRENT, "2", event);
    },
    onPageChange: function (event) {
      this.$sessionsStorage.set("lastVisitPage", event);
      this.$sessionsStorage.set("oldRoute", this.$router.history.current.fullPath);
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = event * this.pagination.perPage - this.pagination.perPage;
      }
      this.getBLPendencyList("Normal", "0", CURRENT, "2", event);
    },
    getBLPendencyList(type, filterIdD, CURRENT, SEARCH, pageNumber) {
      this.BLPendencyList = [];
      let payload = {};
      if (type == "Normal") {
        this.isLoading = true;
      }
      payload = {
        itemCode: "checkBLPendency",
        type: type,
        DCfilterId: filterIdD,
        searchVal: this.filter,
        DCfilterId: filterIdD,
        fromSearch: SEARCH,
        // fromSearch: this.nextPageNo,
        currentPage: this.pagination.currentPage,
        perPage: this.pagination.perPage,
        Filter: this.Filter,
      };

      CommonService.getAllJobList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            console.log("data.BLPendencyList=?", data.BLPendencyList);
            if (type == "Excell") {
              if (data.BLPendencyList && data.BLPendencyList.BLPendencyList.length > 0) {
                this.data = data.BLPendencyList && data.BLPendencyList.BLPendencyList;
                if (SEARCH == 1) {
                  this.total = data.total;
                }
              }
              this.ExcelBtnName = "Export As Excel";
              window.location.href =
                `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
            } else {
              if (data.BLPendencyList && data.BLPendencyList.BLPendencyList.length > 0) {
                this.data = data.BLPendencyList && data.BLPendencyList.BLPendencyList;
                if (SEARCH == 1) {
                  this.total = data.total;
                }
              }
            }
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on JOBList Error: ", error);
        });
    },
  },
};
</script>

<style>
.mainCardBG {
  background-color: #f8f9fa;
}

.mdi {
  margin-left: 5px;
}
.table-responsive {
  max-height: 1000px;
  /* overflow-y: auto; */
}
.table-header {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px; /* Adjust as necessary */
  background-color: #a9e4ce;
  border-color: lightgrey;
  border-bottom-style: none;
  border-style: solid;
  border-width: 2px;
  /* height: 40px; */
  position: sticky;
  top: 0;
  font-size: 11px;
}

.table-body {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  /* max-width: 200px;  */
  /* Adjust as necessary */
}

.table-background thead {
  background-color: #a9e4ce;
  border-color: lightgrey;
  border-bottom-style: none;
  border-style: solid;
  border-width: 2px;
  height: 40px;
  position: sticky;
  top: 0;
  font-size: 11px;
}
.my-custom-scrollbar {
  position: relative;
  height: 550px;
  overflow: auto;
}
.my-custom-scrollbar_xAxis {
  position: relative;
  height: 340px;
  overflow: auto;
}
.table-wrapper-scroll-y {
  display: block;
}
.md-body-1,
.pendencyBody {
  font-size: 11px;
  font-weight: 400;
  letter-spacing: 0.01em;
  line-height: 20px;
}

.table-background > tbody {
  font-size: 11px;
}

.table-background > thead {
  color: black;
}
</style>



// WEBPACK FOOTER //
// blPendencySheet.vue?76b6384b